import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SpxIconRegistryProxyService } from './registry';

@Injectable({
  providedIn: 'root',
})
//TODO spx-ionic-icons should build into /dist instead of local ist
export class SpxNgSeepexIconsService extends SpxIconRegistryProxyService {
  constructor() {
    const matIconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    super(matIconRegistry, sanitizer);
  }

  public override getNamespace(): string {
    return 'seepex';
  }
}
